export const TStatusDisplayId = {
  SpaceTemperature: "DISPID1",
  ActiveSetpoint: "DISPID2",
  Occupancy: "DISPID7",
  HeatCoolMode: "DISPID8",
  DischargeAirTemperature: "DISPID10",
  ChilledWaterSetpoint: "DISPID26",
  LeavingWaterTemperature: "DISPID27",
  EnteringWaterTemperature: "DISPID28",
  ActiveMode: "DISPID34",
  OperatingMode: "DISPID35",
  DuctStatusPressure: "DISPID44",
  SupplyFanStatus: "DISPID50",
  AreaPresentValue: "DISPID67",
  PumpOutput: "DISPID73",
  FlowStatus: "DISPID74",
  BypassFlow: "DISPID75",
  SupplyWaterTemperature: "DISPID114",
  ReturnWaterTemperature: "DISPID115",
  Flow: "DISPID116",
  CompressorEnabled: "DISPID119",
  PresentValue: "DISPID121",
  Name: "DISPID130",
  EquipmentType: "DISPID131",
  Variance: "DISPID132",
  InsideTemperature: "DISPID.InsideTemperature",
  LightingValue: "DISPID.LightingValue",
  ControlMode: "DISPID156",
  ControlAction: "DISPID155",
  SupplyAirPressure: "DISPID158",
  Override: "DISPID152",
  MinimumFlow: "DISPID157",
  Enabled: "DISPID142",
  Status: "DISPID143",
  ChilledWater: "DISPID144",
  Available: "DISPID145",
  Failure: "DISPID146",
  Sequence: "DISPID147",
  ZoneTemperature: "DISPID148",
  CoolSetpoint: "DISPID149",
  HeatSetpoint: "DISPID150",
  Call: "DISPID151",
  DamperPosition: "DISPID153",
  DamperMin: "DISPID154",
  MemberType: "MemberType",
  NewValue: "NewValue",
  MinimumPresentValue: "SPDISPID32",
  MaximumPresentValue: "SPDISPID31",
  RelinquishDefault: "SPDISPID34",
  MultiStateLabel: "SPDISPID2421",
  MultiStateValue: "SPDISPID2422",
  MultiStatePresentValue: "SPDISPID2423",
  SupplyFanProvingStatus: "SPDISPID2476",
  SpaceTemperatureSensor: "spaceSensorRef",
  SupplyFanSpeed: "SupplyFanSpeed",
  OccupancyRequest: "DISPID663",
  AirValvePosition: "DISPID11",
  ChilledWaterTemp: "DISPID26",
  ActiveHeatCoolStptTemp: "ActiveHeatCoolStptTemp",
  ChilledWaterStpointAct: "SPDISPID500",
  AverageSpaceTemperature: "DISPID1354",
  SpaceSensorRef: "spaceSensorRef",
  SpaceSensorRefBCU: "DISPID.InsideTemperature",
  VentOptOACorrected: "ventOptOaSetpointCorrectedRef",
  DuctStaticOptimize: "DISPID1353",
  StaticPressureStpt: "SPDISPID257",
  SAPressureSetpt: "SPDISPID1227",
  DuctPressureSetptReq: "SPDISPID2042",
  ChillerPlantEnabled: "DISPID542",
  SystemModeSC: "SPDISPID2501",
  SystemModeBCU: "SPDISPID1693",
  SAPressureSetpoint: "SPDISPID1421",
  DuctStaticPressureStPt: "DISPID45",
  DischargeAirTempStPt: "DISPID41",
  EvoDuctStaticPressureSpt: "DuctStaticPressureSpt",
  ActiveRequest: "DISPID1358",
  StatusRef: "DISPID1359",
  SystemOk: "DISPID1362",
  RequestsRef: "requestsRef",
  ResponseTrigger: "DISPID1361",
  CumulativePercent: "cumulativePctRef",
  ImportanceMultiplier: "multiplierRef",
  NetRequests: "netRequestsRef",
  OperatingModeTrim: "currentStateRef",
  TrimValue: "trimValueRef",
  ResponseValue: "respondValueRef",
  IgnoredRequests: "ignoredRequestsRef",
  RunMode: "desiredStateRef",
  ModeStatus: "MnetModeStatus",
  FanSpeed: "MnetFanSpeed",
  VaneDirection: "MnetVaneDirection",
  CommunicationStatus: "CommunicationStatus",
  SetPointType: "MnetAutoModeType",
  VRFSpaceTempActive: "SpaceTempActive",
  HeatCoolModeStatus: "HeatCoolModeStatus",
  BoolTrimValue: "boolTrimValueRef",
  SystemRequests: "systemRequestsRef",
  AlarmRelayOutputStatus: "AlarmRelayOutputStatus",
  BoilerStatus: "BoilerStatus",
  BoilerEnable: "BoilerEnable",
  BoilerTempSptActive: "BoilerTempSptActive",
  BoilerLeavingTemp: "BoilerLeavingTemp",
};

export const TStatusPropertyId = {
  // Description Settings
  ObjectName: 77,
  Description: 28,
  Polarity: 84,
  Deadband: 25,
  Units: 117,
  EvoReference: 21004,
  PropertyReference: 1002,
  UpdateInterval: 21005,
  UpdatePriority: 21015,
  HeartbeatInterval: 21016,

  // Value Settings
  MinimumPresentValue: 69,
  MaximumPresentValue: 65,
  PresentValue: 85,
  EvoMinimumPresentValue: 21017,
  EvoMaximumPresentValue: 21018,
  ChangeofValueIncrement: 22,
  EvoMultiplier: 21006,
  EvoOffset: 21007,
  Multiplier: 10187,
  Offset: 10188,
  DefaultValue: 104,
  ActiveText: 4,
  InactiveText: 46,
  MinimumOnTime: 67,
  MinimumOffTime: 66,
  NumberOfStates: 74,
  StateText: 110,
  EvoAnalogValueTable: 21020,
  MultistateLabel: 14665,
  MultistateValue: 14666,

  // Alarm Settings Actions
  TGPProgramName: 21001,
  TGPEventEnable: 21002,
  TGPBinaryEnable: 21003,
  EventTimeDelay: 113,
  LowLimit: 59,
  HighLimit: 45,
  LimitEnable: 52,
  AlarmValue: 6,
  FeedbackReference: 21019,
  EventAlgorithmInhibitRef: 355,
  AlarmValues: 7,
  FaultValues: 39,

  OnOrOffAlarmLimits: 10172,
  AlarmOnLowLimit: 10176,
  WarningOnLowLimit: 10177,
  WarningOnHighLimit: 10178,
  AlarmOnHighLimit: 10179,
  AlarmOffLowLimit: 10180,
  AlarmOffHighLimit: 10181,
  CPLProgram: 10182,
  EventDeadband: 10175,
  EventMinimumOnTime: 10174,
  EnableAlarm: 30002,
  InputAlarmStateBIOCtlFlags: 10194,
  AlarmingTypeEventEnableSelection: 10196,
  DelayForEnblDsblRfncrGLDSNVTIndex: 14101,
  EnblDsblRfncrEventEnblInput: 10191,
  ControlEventClass: 10198,

  // Event Notification
  EventEnable: 35,
  NotificationClass: 17,
  NotificationType: 72,
};

export const TSubsystemMember = {
  Undefined: 0,
  AreaMember: 1,
  VASAirHandlers: 2,
  VASSpaces: 3,
  VASGroup: 4,
  Chiller: 5,
  Chiller_SC: 6,
  AreaMember_SC: 7,
  VASAirHandlers_SC: 8,
  VASSpaces_SC: 9,
  TRIMRESPOND_SC: 10,
};

export const TMobileFamilyType = {
  VAV_VAS_OBJECT: 153,
  CCP_VAS_OBJECT: 175,
  COMM5_VAS_OBJECT: 190,
  CPC_BCU_FAMILYTYPE: 500,
  CPC_SC_FAMILYTYPE: 501,
  EVO_VAS_FAMILYTYPE: 502,
  BCU_AREA_FAMILYTYPE: 503,
  EVO_AREA_FAMILYTYPE: 504,
  LON_CHILLER_FAMILYTYPE: 505,
  EVO_CHILLER_FAMILYTYPE: 506,
  BCU_VAS_VAV: 507,
  BCU_VAS_CCP: 508,
  BCU_VAS_COMM5: 509,
  TRACKER_VAS: 510,
};

/// The list of resource modules available in the UI Framework.
export const ResourceModules = {
  Alarm: "Alarm",
  Common: "Common",
  DataCollection: "DataCollection",
  DMResources: "DMResources",
  Exception: "Exception",
  GlobalChange: "GlobalChange",
  GlobalPointControl: "GlobalPointControl",
  LogOn: "Logon",
  Navigation: "Navigation",
  ObjectTypeNames: "ObjectTypeNames",
  PropertyNames: "PropertyNames",
  RegularExpressions: "RegEx",
  Schedule: "Schedule",
  SiteManagement: "SiteManagement",
  Status: "Status",
  SystemAdmin: "SystemAdmin",
  UserManagement: "UserManagement",
  ReportManagement: "ReportManagement",
  DataVisaulization: "DataVisualization",
  StandardGraphics: "StandardGraphics",
  TenantServices: "TenantServices",
};

/// The list of OWS family types
export const FamilyType = {
  Undefined: 0,
  Spaces: 1,
  AllEquipment: 2,
  Chillers: 2,
  AirHandlers: 3,
  ProgrammableControllers: 4,
  AllSubsystems: 5,
  ChillerPlants: 5,
  HeatPumpLoops: 6,
  InputOutput: 7,
  BuildingController: 8,
  VariableAirs: 9,
  AllProgrammableControllers: 10,
  BACNet: 10,
  Area: 11,
  Subsystems: 12,
  TrimRespond: 13,
  Meter: 14,
  VRF: 15,
  VRF_Indoor: 16,
  Support: 18,
  Boilers: 19,
  Plants: 20,
};

/// The list of access permissions that can be assigned
/// to a user role for enforcing security.
export const UserAccessPermissions = {
  None: 0,
  View: 1,
  Edit: 2,
  Override: 3,
  ResetPassword: 4,
  Full: 5,
  Create: 20,
  Delete: 21,
  CreateOrDelete: 22,
  Acknowledge: 23,
  InsertComments: 24,
  EditAlarmRouting: 25,
  ConfigureAlarmRecipients: 26,
  ApplyOrCancelExceptions: 27,
  CreateOrEditExceptions: 28,
  ApplyOrCancelSnowDay: 29,
  AdvancedOverrides: 30,
  Ignore: 31, //CR 36479,
  OutOfService: 32,
  SCDeepLink: 33,
  CriticalPoint: 34,
};

/// The list of UI applications.
export const ApplicationAccessPermissions = {
  Alarm: 1,
  Schedule: 2,
  DataLogs: 3,
  AllDataLogs: 4,
  Overrides: 5,
  GlobalAlarm: 6,
  GlobalSchedule: 7,
  GlobalPointControl: 8,
  GlobalCustomization: 9,
  SystemMaintenance: 10,
  SystemLogs: 11,
  GlobalChange: 12,
  SiteAdministration: 20,
  UserAdministration: 21,
  DirectLinkToPanel: 13,
  BACnetViewer: 14,
  ReportManagement: 15,
  CriticalControl: 16,
  CriticalPointPermission: 17,
  TenantService: 18,
  Dashboards: 19,
  WorkOrder: 24,
  BillingInvoices: 29,
};

/// The list of error codes being returned from
/// the application layer
export const ApplicationErrors = {
  Unknown: -1,
  NoError: 0,
  CommError: 1,
  Timeout: 2,
  publicError: 3,
  UcmFamilyDefinitionNotExist: 4,
  UcmProfileNotExist: 5,
  MetadataError: 6,
  AccessRight: 7,
  ArgumentError: 8,
  SiteNoExist: 9,
  PanelOffline: 10,
  UcmReadFailed: 11,
  UcmWriteFailed: 12,
  DatabaseAccessFailed: 13,
  SiteAlreadyDiscovered: 14,
  ProtocolNotSupported: 15,
};

export const TSessionKeys = {
  AttributeSearchAttribute1: "AttribSearch_Attribute1",
  AttributeSearchAttribute2: "AttribSearch_Attribute2",
  AttributeSearchValue1: "AttribSearch_Value1",
  AttributeSearchValue2: "AttribSearch_Value2",
  ExceptionWizardState: "ExceptionWizardState",
  LoginRedirectMessage: "LoginPageRedirectResource",
  LogInUser: "LogInUser",
  ScheduleWizardState: "ScheduleWizardState",
  TreeEditorSaved: "TreeEditorSaved",
  TreeNodeCulture: "TreeNodeCulture",
  ScheduleDays: "TodaysEvents",
  IsModify: "IsModify",
  FromBuildingScheduleSummary: "FromBuildingScheduleSummary",
  NonTESException: "NonTESException",
  MaxIndexOfNonTESExp: "MaxIndexOfNonTESExp",
  TreeBottomNodeCulture: "TreeBottomNodeCulture",
  UserLogOnTransactionId: "UserLogOnTransactionId",
  LogOffRecorded: "LogOffRecorded",
  ContextualNavigation: "ContextualNavigation",
};

export const TDeviceType = {
  Unknown: 0,
  Mobile: 1,
  Tablet: 2,
  Desktop: 3,
};

export const TObjectTypes = {
  // standard objects
  UNDEFINED: -1,
  AnalogInput: 0,
  AnalogOutput: 1,
  AnalogValue: 2,
  BinaryInput: 3,
  BinaryOutput: 4,
  BinaryValue: 5,
};

export const TStatusTabIndices = {
  Graphics: 0,
  Status: 1,
  Alarms: 2,
  Maintenance: 3,
  History: 4,
  Configuration: 5,
  TGP2: 6,
  SupportFiles: 7,
  //Members: 9,
};
